/*
@ts-nocheck
 */
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import iconGreenHeart from "assets/icons/heart-green.svg";
import iconNavbarNotifications from "assets/icons/navbar-notifications.svg";
import iconNavbarProfile from "assets/icons/navbar-profile.svg";
import styled, { css } from "styled-components";

import "./css/style.css";

import StarredModal from "components/modals/starred-modal";
import { Button, Dropdown, Frame, Logo, Row, RowWrapper } from "components/ui-kit/styled-templates";

import UserApi from "api/user-api";

import ModalsService from "services/modals-service";

import useProfileInfoCompleted from "hooks/useProfileInfoCompleted";
import { useStorageListener } from "hooks/useStorage";

import { EModals, ERoles } from "types/enums";
import { useState, useEffect } from "react";
import ProfileIncompleteModal, { getMissingFields } from "components/modals/profile-incomplete-modal";

function MenuIcon (props) {
    return (
        <svg {...props} viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 18L20 18" stroke="#000000" stroke-width="0.9600000000000002" stroke-linecap="round"></path> <path d="M4 12L20 12" stroke="#000000" stroke-width="0.9600000000000002" stroke-linecap="round"></path> <path d="M4 6L20 6" stroke="#000000" stroke-width="0.9600000000000002" stroke-linecap="round"></path> </g></svg>
    );
}

function CloseMenuIcon (props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" {...props} viewBox="0 0 50 50">
        <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
        </svg>
    );
}


const handleClick = (item, ev) => {
    console.log('handleClick occured! ');
    if (item.onClick == undefined) {
        return;
    }
    try {
        item.onClick();
        ev.preventDefault();
    } catch (exc) {
    }
};

const Header = (props) => {
    let {hasLogo = true, hasActionButtons = true} = props;
    const { pathname } = useLocation();

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const role: ERoles = useStorageListener((state) => state?.user?.userRole ?? ERoles.Guest);
    const isClubAdmin = useStorageListener((state) => state?.user?.isClubAdmin ?? false);
    const profileInfoCompleted = useProfileInfoCompleted();
    const user = useStorageListener((state) => state?.user);

    // Проверка заполненности профиля для путешественников
    useEffect(() => {
        if (role === ERoles.Student && user?.id) {
            const missingFields = getMissingFields(user);
            if (missingFields.length > 0) {
                ModalsService.showModal(EModals.ProfileIncomplete, { missingFields });
            }
        }
    }, [role, user?.id, user?.userUniversityId, user?.departureCity, user?.name, user?.phone, user?.gender, user?.birthday, user?.studentRoleType]);

    let navbarItems = {
        [ERoles.Student]: [

            { name: t("kd0cxu9aj0d"), to: "/about-program" },
            { name: t("grz2p1n8qr"), to: "/news" },


            { name: isRu ? 'В Путешествие!' : 'Go travel!',
                options: [
                    { name: t("1kjjamjlil5"), to: "/search" },
                    { name: t("boc9nan75af"), to: "/events-search" },
                    { name: isRu ? 'Университеты' : 'Universities', to: "/universities" },
                    { name: isRu ? 'Международные программы' : 'International programs', to: "/international" },
                    { name: isRu ? 'Активный туризм' : 'Active tourism', to: "/clubs" },
                    { name: isRu ? 'Партнерские инициативы' : 'Partners', to: "/partners" },
                ]
            },

            // { name: t("9sqjqe0i5dp"), to: "/universities" },
            // { name: t("1kjjamjlil5"), to: "/search" },
            // { name: t("boc9nan75af"), to: "/events-search" },
            // { name: isRu ? 'Активный туризм' : 'Active tourism', to: "/clubs" },

            // { name: t("1kjjamjlil6"), to: "/science" },

            { name: isRu ? <>Научно-популярный туризм</> : 'Science',
                options: [
                    // { name: t("1kjjamjlil6"), to: "/science" },
                    { name: isRu ? 'Наука в университетах' : 'Universities science' , to: "/science-labs" },
                    { name: isRu ? 'Турмаршруты' : 'Routes', to: "/science-products" }
                ]
            },

            // { name: t("1nwvn4sd0cb"), to: "/partners" },


            // { name: t("0deej8t75urp"), to: "/search" },
            // { name: t("1kjjamjlil6"), to: "/science" },
            // { name: "Календарь", to: "/calendar" },
            // { name: t("qrz53zn3m1"), to: "/events-search" },
            { name: t("u7qg1zum66"), to: "/bookings" },
            { name: t("ambassadors"), to: "/ambassadors" },
            {
                name: (isRu ? "Полезное" : "Useful"),
                options: [
                    {name: t("ly2nfd3sir"), to: "/contacts"},
                    { name: isRu ? 'Вопросы и ответы' : 'FAQ', to: "/faq" },
                    { name: isRu ? 'Интенсив' : 'Intensive', to: "/intensive" }
                ]
            }
            // { name: "Заявки", to: "/requests" },
        ],
        [ERoles.University]: [
            // { name: "Поиск жилья", to: "/search" },
            // { name: "Календарь", to: "/calendar" },
            // { name: "Бронирования", to: "/bookings" },
            { name: t("2mzycvzoh1t"), to: "/dormitories" },
            { name: t("my_clubs"), to: "/clubs" },
            { name: 'Статистика студтурклубов', to: "/stats-clubs" },
            { name: t("ctrm3onpunt"), to: "/events" },
            // { name: t("xezpz5c4d2"), to: "/reviews" },
            { name: t("xezpz5c4d1"), to: "/labs" },
            // { name: 'Турклубы', to: "/clubs" },
            { name: t("ambassadors"), to: "/ambassadors" },
            {
                name: t("xkx0ksfnons"),
                options: [
                    { name: t("09nyqatr4y4y"), to: "/requests" },
                    { name: t("1h4f132vcgaj"), to: "/event-requests" }
                ]
            }
        ],
        [ERoles.ClubsUniAdmin]: [
            { name: t("my_clubs"), to: "/clubs" },
            { name: t("ctrm3onpunt"), to: "/events" },
            { name: isRu ? 'Заявки на события' : 'Events Requests', to: "/event-requests" },
            { name: isRu ? 'Статистика студтурклубов' : 'Tour clubs stats', to: "/stats-clubs" }
        ],
        [ERoles.Admin]: [
            { name: t("c51gb2lbc0a"), to: "/universities" },
            { name: t("l7n1lckhn8"), to: "/dormitories" },
            { name: 'FAQ', to: "/faqs" },

            { name: t("u7l1dc383b"), to: "/news" },

            // {
            //     name: 'ВУЗы и общежития',
            //     options: [
            //
            //     ]
            // },

            { name: t("1nwvn4sd0cb"), to: "/partners" },
            { name: t("hxsbj0a3dn7"), to: "/questionnaires" },
            { name: t("673yt6ywn06"), to: "/events" },
            { name: 'Студтурклубы', to: "/clubs" },

            {
                name: t("ugqwknen0xf"),
                options: [
                    { name: t("ugqwknen0xf"), to: "/stats" },
                    { name: 'Статистика студтурклубов', to: "/stats-clubs" },
                ]
            },

            // { name: t("ugqwknen0xf"), to: "/stats" },
            // { name: 'Статистика студтурклубов', to: "/stats-clubs" },

            { name: t("ugqwknen0xw"), to: "/labs" },
            { name: t("ambassadors"), to: "/ambassadors" },
            { name: "Отзывы", to: "/reviews" }
        ],
        [ERoles.ClubsAdmin]: [
            { name: isRu ? 'Студтурклубы' : 'Tour clubs', to: "/clubs" },
            { name: t("673yt6ywn06"), to: "/events" },
            { name: isRu ? 'Статистика студтурклубов' : 'Tour clubs stats', to: "/stats-clubs" }
            // { name: t("ugqwknen0xf"), to: "/stats" },

        ]
    };

    const guestNavItems = [
        { name: t("kd0cxu9aj0d"), to: "/about-program" },
        { name: t("grz2p1n8qr"), to: "/news" },

        { name: isRu ? 'В Путешествие!' : 'Go travel!',
            options: [
                { name: t("1kjjamjlil5"), to: "/search" },
                { name: t("boc9nan75af"), to: "/events-search" },
                { name: isRu ? 'Университеты' : 'Universities', to: "/universities" },
                { name: isRu ? 'Международные программы' : 'International programs', to: "/international" },
                { name: isRu ? 'Активный туризм' : 'Active tourism', to: "/clubs" },
                { name: isRu ? 'Партнерские инициативы' : 'Partners', to: "/partners" },
            ]
        },

        // { name: t("1kjjamjlil6"), to: "/science" },
        { name: isRu ? <>Научно-популярный туризм</>  : 'Science',
            options: [
                // { name: t("1kjjamjlil6"), to: "/science" },
                { name: isRu ? 'Наука в университетах' : 'Universities science' , to: "/science-labs" },
                { name: isRu ? 'Турмаршруты' : 'Routes', to: "/science-products" }
            ]
        },

        { name: t("ambassadors"), to: "/ambassadors" },
        // { name: "Куда поехать", to: "/search" },
        // { name: "Зачем поехать", to: "/events" },
        // { name: "Новости", to: "/news" },
        {
            name: (isRu ? "Полезное" : "Useful"),
            options: [
                {name: t("ly2nfd3sir"), to: "/contacts"},
                { name: isRu ? 'Вопросы и ответы' : 'FAQ', to: "/faq" },
                { name: isRu ? 'Интенсив' : 'Intensive', to: "/intensive" }
            ]
        }

        // { name: "Организации", to: "/universities" },
    ];


    let menuItems = {
        [ERoles.Student]: [
            // { name: `Уведомления`, icon: `header-menu-notifications`, to: `/notifications` },
            { name: `Профиль`, to: `/profile` },
            { name: isRu ? `Выход` : 'Logout', onClick: () => {
                    console.log('student: Logout click');
                    UserApi.logout();
            } }
        ],
        [ERoles.University]: [
            {
                name: t("header.menuItems.uni.organisationData"),
                icon: `header-menu-organization-data`,
                to: `/profile-info`
            },
            { name: t("header.menuItems.uni.myDorms"), icon: `header-menu-my-campuses`, to: `/dormitories` },
            { name: t("header.menuItems.uni.reviews"), icon: `header-menu-my-campuses`, to: `/reviews` },
            // { name: `Мероприятия`, icon: `header-menu-notifications`, to: `/events` },
            // { name: `Уведомления`, icon: `header-menu-notifications`, to: `/notifications` },
            // { namehandleClick: `Безопасность`, icon: `header-menu-security`, to: `/security` },
            { name: t("header.menuItems.uni.logout"), onClick: UserApi.logout }
        ],
        [ERoles.Admin]: [{ name:  isRu ? `Выход` : 'Logout', onClick: UserApi.logout }],
        [ERoles.ClubsAdmin]: [{ name:  isRu ? `Выход` : 'Logout', onClick: UserApi.logout }],
        [ERoles.ClubsUniAdmin]: [{ name:  isRu ? `Выход` : 'Logout', onClick: UserApi.logout }],
        [ERoles.Guest]: guestNavItems
    };

    console.log("role = ", role);
    console.log("menuItems = ", menuItems);

    let navItems = navbarItems[role];
    if (role == 'guest'){
        navItems = guestNavItems;
    }

    console.log("navItems = ", navItems);

    let flatNavItems = navItems.reduce((acc, item) => {
        if (item.options) {
            return [...acc, ...item.options];
        }
        return [...acc, item];
    }, []);

    const changeLang = (lang: string) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("lang", lang);
    };

    const openStarredModal = () => {
        ModalsService.showModal(EModals.Starred);
    };

    return (
        <Wrapper>
            <StarredModal />
            <ProfileIncompleteModal />
            <InnerWrapper>
                <Row extra={`gap: 0 12px;`} className={"header_top_row"}>

                    {hasLogo == false ? null :
                        <Link to="/" className={"header_logo"} id={'header_logo'} >
                            <Logo className={"stud_logo"}/>
                        </Link>
                    }

                    {/*{role === ERoles.Guest &&*/}
                    {/*    guestNavItems.map((item, index) => (*/}
                    {/*        <NavBarItem*/}
                    {/*            className={"guest_nav_item"}*/}
                    {/*            to={item?.to}*/}
                    {/*            key={index}*/}
                    {/*            selected={+pathname?.startsWith?.(item?.to)}*/}
                    {/*            onClick={(e) => {*/}
                    {/*                handleClick(item, e);*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            {item.name}*/}
                    {/*        </NavBarItem>*/}
                    {/*    ))}*/}

                </Row>
                <Row extra={`gap: 0 ${role === ERoles.Guest ? 20 : 25}px;`} className={"header_nav_row !sm:flex hidden "}>
                    {/*{(ERoles.Student === role || ERoles.Guest === role || (ERoles.University === role && profileInfoCompleted === true) || ERoles.Admin === role ||  ERoles.ClubsAdmin === role ||  ERoles.ClubsUniAdmin === role) &&*/}
                    {/*    navItems.map((item, index) =>*/}
                    {/*        item?.options ? (*/}
                    {/*            <Dropdown*/}
                    {/*                key={index}*/}
                    {/*                toggle={() => (*/}
                    {/*                    // <NavBarItem to={item?.to} key={index} selected={+pathname?.startsWith?.(item?.to)}>*/}
                    {/*                    <NavBarItem*/}
                    {/*                        as={Frame}*/}
                    {/*                        key={index}*/}
                    {/*                        selected={false}*/}
                    {/*                        onClick={(e) => {*/}
                    {/*                            handleClick(item, e);*/}
                    {/*                        }}*/}
                    {/*                    >*/}
                    {/*                        {item.name}*/}
                    {/*                    </NavBarItem>*/}
                    {/*                )}*/}
                    {/*                menu={() => (*/}
                    {/*                    <>*/}
                    {/*                        {item?.options?.map?.((option, index) => (*/}
                    {/*                            <HeaderDropdownItem key={index} to={option.to}>*/}
                    {/*                                {option.name}*/}
                    {/*                            </HeaderDropdownItem>*/}
                    {/*                        ))}*/}
                    {/*                    </>*/}
                    {/*                )}*/}
                    {/*                menuProps={{ extra: `padding: 17px 20px; > * { gap: 15px; };` }}*/}
                    {/*            />*/}
                    {/*        ) : (*/}
                    {/*            <NavBarItem*/}
                    {/*                to={item?.to}*/}
                    {/*                key={index}*/}
                    {/*                selected={+pathname?.startsWith?.(item?.to)}*/}
                    {/*                onClick={(e) => {*/}
                    {/*                    handleClick(item, e);*/}
                    {/*                }}*/}
                    {/*            >*/}
                    {/*                {item.name}*/}
                    {/*            </NavBarItem>*/}
                    {/*        )*/}
                    {/*    )}*/}

                    {(ERoles.Student === role || ERoles.Guest === role || (ERoles.University === role && profileInfoCompleted === true) || ERoles.Admin === role ||  ERoles.ClubsAdmin === role ||  ERoles.ClubsUniAdmin === role) &&
                        navItems.map((item, index) =>
                            item?.options ? (
                                <div className={'xx_top_nav_placeholder hidden sm:block'} >
                                    <NavBarItem
                                        as={Frame}
                                        key={index}
                                        selected={false}
                                        onClick={(e) => {
                                            handleClick(item, e);
                                        }}
                                    >
                                        {item.name}
                                    </NavBarItem>
                                    <div className={'xx_top_nav_drop hidden'} >
                                        {item?.options?.map?.((option, index) => (
                                            <HeaderDropdownItem className={'xx_top_drop_item'} key={index} to={option.to}>
                                                {option.name}
                                            </HeaderDropdownItem>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <NavBarItem
                                    to={item?.to}
                                    key={index}
                                    selected={+pathname?.startsWith?.(item?.to)}
                                    onClick={(e) => {
                                        handleClick(item, e);
                                    }}
                                    onTouchStart={e => {
                                        handleClick(item, e);
                                    }}
                                >
                                    {item.name}
                                </NavBarItem>
                            )
                        )}



                    {hasActionButtons == false ? null :
                        <Dropdown
                            toggle={() => <div>{(i18n.language || "").toUpperCase()}</div>}
                            toggleProps={{ extra: `padding: 0 10px; cursor: pointer; color: #00A19A;` }}
                            menu={() => {
                                return (
                                    <>
                                        {["ru", "en"].map((lang, index) => (
                                            <span key={index} onClick={() => changeLang(lang)}
                                                  style={{ cursor: "pointer" }}>
                                            {lang.toUpperCase()}
                                        </span>
                                        ))}
                                    </>
                                );
                            }}
                            menuProps={{ extra: "> * { gap: 1rem; }" }}
                        />
                    }
                    {role === ERoles.Guest && hasActionButtons == true && (
                        <>
                            {/* <Link to="/registration/university">Регистрация для организации</Link> */}
                            {/*<Link to="/registration/student" className={'header_signup_button'} >*/}
                            {/*    <Button variant="outlined">{t("izmu3mp2cxl")}</Button>*/}
                            {/*</Link>*/}
                            <Link to="/login" className={'header_login_button'} >
                                <Button>{t("4jps5krfkff")}</Button>
                            </Link>
                        </>
                    )}
                    {role === ERoles.Student &&
                        <img alt="Heart" src={iconGreenHeart} onClick={openStarredModal} className="cursor-pointer" />}
                    {role !== ERoles.Guest && (
                        <Link to="/notifications">
                            <img alt="Notifications" src={iconNavbarNotifications} className="w-6 h-6 cursor-pointer" />
                        </Link>
                    )}
                    {role !== ERoles.Guest && (
                        <Dropdown
                            // toggle={() => <ProfileIcon />}
                            toggle={() => <img alt="Profile" src={iconNavbarProfile}
                                               className="w-6 h-6 cursor-pointer" />}
                            menuProps={{ extra: `padding: 20px;` }}
                            scrollWrapperStyles={css`
                              gap: 16px 0;
                              align-items: flex-start;
                              justify-content: flex-start;
                              width: max-content;
                            `}
                            menu={() => (
                                <>
                                    {menuItems[role].map((item: any, index: number) => (
                                        <MenuItem
                                            className={"guest_menu_item"}
                                            key={index}
                                            {...item}
                                            as={!!item?.to ? Link : Frame}
                                            label={item.name}
                                        />
                                    ))}
                                </>
                            )}
                        />
                    )}
                </Row>
                <MenuContainer>
                {role === ERoles.Student &&
                        <img alt="Heart" src={iconGreenHeart} onClick={() => {
                            openStarredModal();
                            setMobileMenuOpen(false)
                        }} className="cursor-pointer" />}
                    {role !== ERoles.Guest && (
                        <Link to="/notifications">
                            <img alt="Notifications" src={iconNavbarNotifications} className="w-6 h-6 cursor-pointer" onClick={() => setMobileMenuOpen(false)} />
                        </Link>
                    )}
                    {role !== ERoles.Guest && (
                        <Dropdown
                            // toggle={() => <ProfileIcon />}
                            toggle={() => <img alt="Profile" src={iconNavbarProfile} className="w-6 h-6 cursor-pointer" />}
                            menuProps={{ extra: `padding: 20px;` }}
                            scrollWrapperStyles={css`
                            gap: 16px 0;
                            align-items: flex-start;
                            justify-content: flex-start;
                            width: max-content;
                            `}
                            menu={() => (
                                <>
                                    {menuItems[role].map((item: any, index: number) => (
                                        <MenuItem
                                            className={"guest_menu_item"}
                                            key={index}
                                            {...item}
                                            as={!!item?.to ? Link : Frame}
                                            label={item.name}
                                            onClick={() => setMobileMenuOpen(false)}
                                        />
                                    ))}
                                </>
                            )}
                        />
                    )}
                    <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                        {mobileMenuOpen ? <CloseMenuIcon width={32} height={32}/> : <MenuIcon width={32} height={32} />}
                    </button>
                </MenuContainer>
            </InnerWrapper>
            <MobileMenu isOpen={mobileMenuOpen} className="z-[1] h-full overflow-y-hidden flex flex-col items-start">
                {(role === ERoles.Guest || ERoles.Student === role ) &&
                    flatNavItems.map((item, index) => (
                            <NavBarItem
                                className={"guest_nav_item"}
                                to={item?.to}
                                key={index}
                                selected={+pathname?.startsWith?.(item?.to)}
                                onClick={(e) => {
                                    handleClick(item, e);
                                    setMobileMenuOpen(false);
                                }}
                                
                            >
                                {item.name}
                            </NavBarItem>
                        ))}
                    {((ERoles.University === role && profileInfoCompleted === true) || ERoles.Admin === role) &&
                        navbarItems[role].map((item, index) =>
                            item?.options ? (
                                <Dropdown
                                    key={index}
                                    toggle={() => (
                                        // <NavBarItem to={item?.to} key={index} selected={+pathname?.startsWith?.(item?.to)}>
                                        <NavBarItem
                                            as={Frame}
                                            key={index}
                                            selected={false}
                                            onClick={(e) => {
                                                handleClick(item, e);
                                                setMobileMenuOpen(false)
                                            }}
                                        >
                                            {item.name}
                                        </NavBarItem>
                                    )}
                                    menu={() => (
                                        <>
                                            {item?.options?.map?.((option, index) => (
                                                <HeaderDropdownItem key={index} to={option.to}>
                                                    {option.name}
                                                </HeaderDropdownItem>
                                            ))}
                                        </>
                                    )}
                                    menuProps={{ extra: `padding: 17px 20px; > * { gap: 15px; };` }}
                                />
                            ) : (
                                <NavBarItem
                                    to={item?.to}
                                    key={index}
                                    selected={+pathname?.startsWith?.(item?.to)}
                                    onClick={(e) => {
                                        handleClick(item, e);
                                        setMobileMenuOpen(false)
                                    }}
                                >
                                    {item.name}
                                </NavBarItem>
                            )
                        )}

            </MobileMenu>
        </Wrapper>
    );
};

const HeaderDropdownItem = styled(Link)`
  font-size: 14px;
  line-height: 19px;
  color: ${({ theme }) => theme.text.primary};
  opacity: 0.7;

  width: max-content;
`;

const MenuItem = styled(Link)<{ icon: string; label: string }>`
  display: flex;
  flex-direction: row;
  cursor: pointer;

  &:hover {
    &:after {
      transform: translateX(3px);
    }
  }

  &:before {
    content: "";
    ${({ icon }) =>
            icon &&
            css`
              width: 20px;
              height: 20px;
              background: url("${require(`assets/icons/${icon}.svg`)}") no-repeat center center / contain;
              margin-right: 14px;
            `};
  }

  &:after {
    content: "${({ label }) => label}";
    color: ${({ theme }) => theme.text.primary};
    transition: 0.2s;
  }
`;

const NavBarItem = styled(Link)<{ selected: number }>`
  font-weight: 400;
  font-size: 15px;
  cursor: pointer;
  line-height: 20px;
  cursor: pointer;
  color: ${({ theme }) => theme.text.primary};
  
  :hover{
    color: #02BF89;
  }
  
  font-family: "Noto Sans", sans-serif;
  
  padding: 4px 0;
  box-sizing: border-box;

  @media (max-width: 1380px) {
    font-size: 14px;
  }
  
  @media (max-width: 1280px) {
    font-size: 13px;
  }

  @media (max-width: 720px) {
    font-size: 20px;
  }

  ${({ theme, selected }) => `border-bottom: 2px solid ${selected ? theme.blue : `transparent`};`}
`;

const Wrapper = styled(Frame)`
  width: 100vw;
  padding: calc(36px - 14px);
  box-sizing: border-box;
  background: ${({ theme }) => theme.lightblue};
`;

const InnerWrapper = styled(RowWrapper)`
  width: 100%;
  max-width: 1400px;
  @media (max-width: 720px) {
    /* display: block; */
  }
`;

const MenuContainer = styled(InnerWrapper)`
    width: 100%;
    position: relative;
    padding: 1.5rem;
    display: none;
    justify-content: end;
    gap: 20px;
    @media (max-width: 720px) {
        display: flex;
    }

`  

const MobileMenu = styled.nav<{isOpen: boolean}>`
  display: none;
  gap: 12px;

  @media (max-width: 720px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background-color: #f4f9fc;
    padding: 20px;
    text-align: center;
    margin-top: 40px;
  }
`;

export default Header;
